<template>
  <div class="jumbotron">
    <div class="row">
      <div class="col btn-col">
        <button v-if="!savedBusiness || (getUserType !== 'user')" v-on:click="saveBusiness" class="btn btn-secondary">
          <i class="fa fa-bookmark" aria-hidden="true"></i>Save
        </button>
        <button v-if="savedBusiness && (getUserType === 'user')" v-on:click="removeBusiness" class="btn btn-secondary saved-button">
          <i class="fa fa-check" aria-hidden="true"></i>Saved
        </button>
      </div>
      <div class="col btn-col">
        <button v-on:click="showShareModal" class="btn btn-secondary">
          <i class="fa fa-share-alt" aria-hidden="true"></i>Share
        </button>
      </div>
    </div>
    <div v-if="!isGoogle" class="row">
      <div v-if="enableQuoteRequest" class="col btn-col request-col">
        <button v-on:click="showQuoteModal" class="btn btn-secondary">
          <i class="fa fa-comments" aria-hidden="true"></i>Request Quote
        </button>
      </div>
    </div>
    <div class="alert-wrapper">
      <b-alert variant="success"
               dismissible
               :show="saved"
               @dismissed="saved=false">
        Business Saved
      </b-alert>
      <b-alert variant="success"
               dismissible
               :show="unsaved"
               @dismissed="unsaved=false">
        Removed Saved Business
      </b-alert>
      <b-alert variant="warning"
               dismissible
               :show="mustBeUser"
               @dismissed="mustBeUser=false">
        Please Sign In to Continue.
      </b-alert>
      <b-alert variant="warning"
               dismissible
               :show="mustHaveName"
               @dismissed="mustHaveName=false">
        Please add your <router-link to="/profile/user/details"><u>First Name</u></router-link> to your profile details to send a message.
      </b-alert>
    </div>
    <div v-if="availabilityProp" class="row icon-row" v-bind:class="{'fa-history-green': availabilityProp === 100,'fa-history-orange': availabilityProp === 200,'fa-history-red': availabilityProp > 200}">
      <div class="col-2 my-auto text-right">
        <span class="fas-wrapper">
          <i class="fas fa-history"></i>
        </span>
      </div>
      <div class="col-10 my-auto">
        <p class="icon-label">{{ availability.text }}</p>
      </div>
    </div>
    <div v-if="emergenciesProp" class="row icon-row">
      <div class="col-2 my-auto text-right">
        <i class="fas fa-phone"></i>
      </div>
      <div class="col-10 my-auto">
        <p class="icon-label">Available for Emergencies</p>
      </div>
    </div>
    <div v-if="costLevelProp" class="row icon-row">
      <div class="col-2 my-auto text-right">
        <svg viewBox="0 0 17 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" class="si-glyph si-glyph-money-$">
          <!-- Generator: Sketch 3.0.3 (7891) - http://www.bohemiancoding.com/sketch -->
          <title>893</title>
          <defs></defs>
          <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <path d="M11.979,10.596 C11.979,8.901 10.621,7.492 8.968,7.215 L8.968,3.828 C9.472,3.984 9.993,4.023 10.203,4.498 C10.393,4.926 10.874,5.109 11.275,4.908 C11.678,4.706 11.848,4.194 11.659,3.765 C11.186,2.699 10.117,2.271 8.983,2.077 L8.983,0 L8,0 L8,2.066 C6.336,2.317 5.005,3.736 5.005,5.449 C5.005,7.159 6.329,8.576 8,8.832 L8,12.242 C7.464,12.094 6.967,12.044 6.748,11.547 C6.56,11.117 6.08,10.934 5.68,11.135 C5.276,11.336 5.104,11.846 5.292,12.276 C5.773,13.366 6.846,13.807 8.016,13.987 L8.016,16 L8.954,16 L8.954,13.979 C10.6,13.707 11.979,12.294 11.979,10.596 L11.979,10.596 Z M6.617,5.449 C6.617,4.675 7.215,4.025 8.03,3.816 L8.03,7.085 C7.215,6.874 6.617,6.225 6.617,5.449 L6.617,5.449 Z M8.961,12.223 L8.961,8.969 C9.776,9.194 10.371,9.834 10.371,10.596 C10.371,11.358 9.776,11.998 8.961,12.223 L8.961,12.223 Z" fill="#434343" class="si-glyph-fill"></path>
          </g>
        </svg>
      </div>
      <div class="col-10 my-auto">
        <p class="icon-label">Avg. Cost {{costLevel.text}}</p>
      </div>
    </div>
    <div v-if="insuredProp" class="row icon-row">
      <div class="col-2 my-auto text-right">
        <i class="fas fa-umbrella"></i>
      </div>
      <div class="col-10 my-auto">
        <p class="icon-label">Has Insurance</p>
      </div>
    </div>
    <div v-if="licensedProp" class="row icon-row">
      <div class="col-2 my-auto text-right">
        <i class="fas fa-certificate"></i>
      </div>
      <div class="col-10 my-auto">
        <p class="icon-label">Is Licensed</p>
      </div>
    </div>

    <div v-if="serviceType.length === 1" class="row icon-row">
      <div class="col-10 my-auto">
        <p class="icon-label">Available for {{serviceType[0]}} services</p>
      </div>
    </div>
    <div v-if="serviceType.length === 2" class="row icon-row">
      <div class="col-10 my-auto">
        <p class="icon-label">Available for {{serviceType[0]}} and {{serviceType[1]}} services</p>
      </div>
    </div>

    <div v-if="images.length !== 0" class="row photos-section">
      <div class="col">
        <h4 class="cursor-pointer" v-on:click="$emit('select-photos')">Photos</h4>
      </div>
    </div>
    <div v-if="images.length !== 0" class="row">
      <div class="col text-center">
        <div class="image-wrapper">
          <img class="preview-image" v-for="(image, index) in firstImages" :key="index" v-bind:src="image">
        </div>
      </div>
    </div>
    <share-modal ref="shareModal" v-bind:shareType="'Business'" v-bind:typeData="shareData"></share-modal>
    <b-modal id="quoteModal" ref="quoteModal" size="lg" hide-footer>
      <div slot="modal-header" class="w-100 justify-content-center share-modal-header">
        <h3>Request A Quote</h3>
        <button v-on:click="hideQuoteModal" class="close d-inline" type="button" aria-label="Close">x</button>
      </div>
      <div v-if="!submitted">
        <div class="container">
          <div class="form-group">
            <label for="">Subject</label>
            <input type="text" v-model="subject" class="form-control" aria-describedby="subject" placeholder="What is the name of your project?">
          </div>
          <div class="form-group">
            <label>Message</label>
            <textarea v-model="quoteMessage" class="form-control" rows="8" placeholder="Tell us about your project! Be sure to include a project description, timeline, and cost considerations (if any). The more you tell our Service Provider, the better we can serve you!"></textarea>
          </div>
          <div class="row">
            <div class="col-md-6 second">
              <button v-on:click="hideQuoteModal" class="btn btn-secondary">Cancel</button>
            </div>
            <div class="col-md-6">
              <button v-on:click="initiateQuoteRequest" class="btn btn-primary">Submit</button>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <p>Your request has been submitted. You can view your requests on your <router-link to="/profile/user/dashboard"><u>Dashboard</u>.</router-link></p>
      </div>
    </b-modal>
    <auth-modal ref="authModal"></auth-modal>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import AuthModal from '../../authentication/TheAuthModal.vue'
import ShareModal from '../../general/modals/TheShareModal.vue'

export default {
  components: {
    AuthModal,
    ShareModal
  },
  data () {
    return {
      saved: false,
      mustBeUser: false,
      unsaved: false,
      quoteMessage: null,
      subject: null,
      submitted: false,
      mustHaveName: false
    }
  },
  props: {
    businessName: String,
    costLevelProp: Number,
    availabilityProp: Number,
    insuredProp: Number,
    licensedProp: Boolean,
    enableQuoteRequest: Boolean,
    emergenciesProp: String,
    images: Array,
    serviceType: Array
  },
  methods: {
    ...mapActions('user', [
      'putUserData'
    ]),
    ...mapMutations('user', [
      'addSavedBusiness',
      'removeSavedBusiness'
    ]),
    showShareModal () {
      if (this.getUserType === 'user') {
        this.$refs.shareModal.$refs.shareModal.show()
      } else {
        this.mustBeUser = true
        if (this.getUserType !== 'business') this.$refs.authModal.$refs.authModal.show()
      }
    },
    hideQuoteModal () {
      this.$refs.quoteModal.hide()
    },
    showQuoteModal () {
      if (this.getUserType === 'user') {
        if (this.getLegalFirstName) {
          this.submitted = false
          this.$refs.quoteModal.show()
        } else {
          this.mustHaveName = true
        }
      } else {
        this.mustBeUser = true
        if (this.getUserType !== 'business') this.$refs.authModal.$refs.authModal.show()
      }
    },
    async initiateQuoteRequest () {
      this.submitted = true
      var client = this.$store.getters.getMessageApigClientFactory
      var params = {}
      var pathTemplate = '/messages'
      var method = 'POST'
      var additionalParams = {}
      var body = {
        message: this.quoteMessage,
        sender: this.getCognitoId,
        recipients: this.businessId,
        category: 'Quote Request',
        subject: this.subject
      }
      try {
        await client.invokeApi(params, pathTemplate, method, additionalParams, body)
      } catch (error) {
        console.log(error)
      }
    },
    async removeBusiness () {
      if (this.getUserType === 'user') {
        this.removeSavedBusiness(this.$route.params.id)
        await this.putUserData()
        this.saved = false
        this.unsaved = true
      } else {
        this.mustBeUser = true
        if (this.getUserType !== 'business') this.$refs.authModal.$refs.authModal.show()
      }
    },
    async saveBusiness () {
      if (this.getUserType === 'user') {
        this.addSavedBusiness(this.$route.params.id)
        await this.putUserData()
        this.unsaved = false
        this.saved = true
      } else {
        this.mustBeUser = true
        if (this.getUserType !== 'business') this.$refs.authModal.$refs.authModal.show()
      }
    }
  },
  computed: {
    ...mapGetters('user', [
      'getSavedBusinesses',
      'getUserType',
      'getLegalFirstName'
    ]),
    ...mapGetters([
      'getCognitoId'
    ]),
    isGoogle () {
      if (this.$route.params.google === 'true') {
        return true
      } else {
        return false
      }
    },
    businessId () {
      return this.$route.params.id
    },
    savedBusiness () {
      return this.getSavedBusinesses.includes(this.$route.params.id)
    },
    shareData () {
      return {
        name: this.businessName,
        url: window.location.href
      }
    },
    firstImages () {
      if (this.images) {
        return this.images.slice(0, 4)
      }
    },
    costLevel () {
      if (this.costLevelProp === 100) {
        return {
          image: '/static/16.png',
          text: '$'
        }
      } else if (this.costLevelProp === 200) {
        return {
          image: '/static/16.png',
          text: '$$'
        }
      } else if (this.costLevelProp === 300) {
        return {
          image: '/static/16.png',
          text: '$$$'
        }
      } else {
        return {
          image: '/static/16.png',
          text: '$$$$'
        }
      }
    },
    availability () {
      if (this.availabilityProp === 100) {
        return {
          image: '/static/12.png',
          text: 'Available in: 0-2 weeks'
        }
      } else if (this.availabilityProp === 200) {
        return {
          image: '/static/13.png',
          text: 'Available in: 1-2 months'
        }
      } else {
        return {
          image: '/static/14.png',
          text: 'Available in: 2 months'
        }
      }
    },
    insured () {
      if (this.insuredProp > 0) {
        return true
      } else {
        return false
      }
    },
    licensed () {
      if (this.licensedProp) {
        return true
      } else {
        return false
      }
    },
    emergencies () {
      if (this.emergenciesProp !== 'No') {
        return true
      } else {
        return false
      }
    }
  }
}
</script>

<style scoped>
@media (max-width: 992px) {
  .second {
    -ms-flex-order: 2;
    order: 2;
  }
}

.fa-certificate, .fa-umbrella {
  color: #363E49;
}

.fa-history-green {
  color: green;
}

.fa-history-orange {
  color: orange;
}

.fa-history-red {
  color: red;
}

.fa-phone {
  color: red;
}

.icon-row {
  margin-top: .6rem;
}

.fas {
  font-size: 2rem;
}

.photos-section {
  margin-top: 1rem;
}

.modal-row {
  padding-bottom: 1rem;
}

.share-modal-header {
  position: relative;
  height: 30px;
}

.fa {
  margin-right: .6rem;
}

.btn-secondary {
  width: 100% !important;
}

.btn-col {
  padding-left: .3rem;
  padding-right: .3rem;
}

.request-col {
  padding-top: .6rem;
}

.cursor-pointer {
  cursor: pointer;
}

.preview-image {
  object-fit: cover;
  height: 150px;
  width: 48%;
}

.icon-label {
  margin-bottom: 0px !important;
}

.needs-padding {
  margin-top: 1rem;
}

.emergency-label {
  font-size: 16px;
}

.small-margin {
  padding-right: .1rem;
  padding-left: .1rem;
}

.alert-wrapper >>> .alert {
  margin-top: 1rem;
}

.close {
  position: absolute;
  text-shadow: none;
  right: 0;
  top: 0;
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/business/leftSide/LeftSide.vue